<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{skuData.long_description}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <sku-trend-mock :artefact="artefact" type="sku" :key="skuData.sku_id"></sku-trend-mock>
        <!-- COMPETITOR -->
        <!-- <div class="flex items-end mb-base" v-if="Object.entries(this.skuData).length > 0">
          <p class="text-lg font-small">{{ dataName  }}</p>
        </div> -->
        
        <div class="flex items-end">
          <vs-chip color="gray">Override Estimate</vs-chip>
        </div>
        <vs-table stripe :data="users">
          <template slot="thead">
            <vs-th>% override</vs-th>
            <vs-th>2</vs-th>
            <vs-th>4</vs-th>
            <vs-th>6</vs-th>
            <vs-th>8</vs-th>
          </template>
          <template>
            <vs-tr>
              <vs-td>% Rev. Lift</vs-td>
              <vs-td>1.6</vs-td>
              <vs-td>1.3</vs-td>
              <vs-td>1.5</vs-td>
              <vs-td>1.2</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>% Profit Margin</vs-td>
              <vs-td>6</vs-td>
              <vs-td>2</vs-td>
              <vs-td>3</vs-td>
              <vs-td>4</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="flex items-end mt-base cursor-pointer">
          <feather-icon icon="LinkIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium text-primary" @click="showCompetition()" v-if="!competeView">View Competitor Info</span>
          <span class="leading-none font-medium text-primary" @click="showRecommend()" v-if="competeView">Back</span>
        </div>
        <!-- NAME -->
        <!-- <vs-input label="Product Link" v-model="dataLink" class="mt-5 w-full" name="item-link" /> -->
        <!-- <span class="text-danger text-sm" v-show="errors.has('item-link')">{{ errors.first('item-link') }}</span> -->

      </div>
    </VuePerfectScrollbar>

    <!-- <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || true">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div> -->
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import SkuTrendMock from "./SkuTrendMock.vue";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    },
    artefact: { type: Object, required: true },
  },
  watch: {
    isSidebarActive(val) {
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        let { category, id, img, name, link, order_status, price } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.dataImg = img
        this.dataName = name
        this.dataLink = link
        this.dataOrder_status = order_status
        this.dataPrice = price
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {

      dataId: null,
      dataName: "",
      dataLink: "",
      dataCategory: null,
      dataImg: null,
      dataOrder_status: "pending",
      dataPrice: 0,
      dataJustIn: false,
      competeView: false,

      competitors: [
        {text:'Audio',value:'audio'},
        {text:'Computers',value:'computers'},
        {text:'Fitness',value:'fitness'},
        {text:'Appliance',value:'appliance'}
      ],

      order_status_choices: [
        {text:'Pending',value:'pending'},
        {text:'Canceled',value:'canceled'},
        {text:'Delivered',value:'delivered'},
        {text:'On Hold',value:'on_hold'}
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },

      users: [
        {
          "id": 1,
          "name": "Leanne Graham",
          "username": "Bret",
          "email": "Sincere@april.biz",
          "website": "hildegard.org",
        },
        {
          "id": 2,
          "name": "Ervin Howell",
          "username": "Antonette",
          "email": "Shanna@melissa.tv",
          "website": "anastasia.net",
        },
        {
          "id": 3,
          "name": "Clementine Bauch",
          "username": "Samantha",
          "email": "Nathan@yesenia.net",
          "website": "ramiro.info",
        },
        {
          "id": 4,
          "name": "Patricia Lebsack",
          "username": "Karianne",
          "email": "Julianne.OConner@kory.org",
          "website": "kale.biz",
        },
        {
          "id": 5,
          "name": "Chelsey Dietrich",
          "username": "Kamren",
          "email": "Lucio_Hettinger@annie.ca",
          "website": "demarco.info",
        },
        {
          "id": 6,
          "name": "Mrs. Dennis Schulist",
          "username": "Leopoldo_Corkery",
          "email": "Karley_Dach@jasper.info",
          "website": "ola.org",
        },
        {
          "id": 7,
          "name": "Kurtis Weissnat",
          "username": "Elwyn.Skiles",
          "email": "Telly.Hoeger@billy.biz",
          "website": "elvis.io",
        },
        {
          "id": 8,
          "name": "Nicholas Runolfsdottir V",
          "username": "Maxime_Nienow",
          "email": "Sherwood@rosamond.me",
          "website": "jacynthe.com",
        },
        {
          "id": 9,
          "name": "Glenna Reichert",
          "username": "Delphine",
          "email": "Chaim_McDermott@dana.io",
          "website": "conrad.com",
        },
        {
          "id": 10,
          "name": "Clementina DuBuque",
          "username": "Moriah.Stanton",
          "email": "Rey.Padberg@karina.biz",
          "website": "ambrose.net",
        },
      ]
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataName
    },
    skuData(){
      return this.data && this.data.length > 0 ? this.data[0] : {}
    }
  },
  methods: {
    initValues() {
      if(this.data.name) return
        this.dataId = null
        this.dataName = ""
        this.dataLink = ""
        this.dataCategory = null
        this.dataOrder_status = "pending"
        this.dataPrice = 0
        this.dataImg = null,
        this.dataJustIn = false
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          if (result) {
            const obj = {
              id: this.dataId,
              name: this.dataName,
              link: this.dataLink,
              img: this.dataImg,
              category: this.dataCategory,
              order_status: this.dataOrder_status,
              price: this.dataPrice,
              justIn: this.dataJustIn
            }

            if(this.dataName !== null && this.dataName.length >= 0) {
              this.$store.dispatch("dataList/updateItem", obj).catch(err => { console.error(err) })
            }else{
              delete obj.id
              obj.popularity = 0
              this.$store.dispatch("dataList/addItem", obj).catch(err => { console.error(err) })
            }

            this.$emit('closeSidebar')
            this.initValues()
          }
      })
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    getStockStatusColor() {
      if (this.dataPrice > 0)
        return this.dataJustIn ? "warning" : "success";
      return "danger";
    },
    getStockStatus(tr) {
      if (this.dataPrice > 0)
        return this.dataJustIn ? "Back in Stock" : "In Stock";
      return "Out of Stock";
    },
    showCompetition() {
      // this.callInProgress = true;
      this.competeView = true;
      this.isSidebarActiveLocal = false
      this.$router.push("/competer/sku/" + this.skuData.sku_id);
      // window.open("/competer/sku/721555", "_blank");
      // window.open("/competer/sku/" + this.skuData.sku_id, "_blank");
    },
    showRecommend() {
      this.competeView = false;
      this.$router.back();
    }
  },
  components: {
    VuePerfectScrollbar,
    SkuTrendMock,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
